// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__oxFPw","inner":"styles_inner__s9P__","expand":"styles_expand__cMcAQ"};